import { Component, OnInit } from '@angular/core';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProcessedSalonCountService } from '../../../api/processed-salon-count.service';

@Component({
  selector: 'app-processed-salon-counts',
  templateUrl: './processed-salon-counts.component.html',
})
export class ProcessedSalonCountsComponent implements OnInit {
  public dataSource: any;
  public countData: any;

  private _destroyed$ = new Subject();

  constructor(private processedSalonCountService: ProcessedSalonCountService) { }

  ngOnInit() {
	this.processedSalonCountService.getFinalProcessedSalonCounts()
		.pipe(takeUntil(this._destroyed$))
		.subscribe(res => {
		if (res) {
			// this.countData = res;
			// let data = this.initPivotDataFields();
			this.countData = {
			fields: [
				{
				caption: 'Report',
				dataField: 'ReportName',
				area: 'filter',
				},
				{
				caption: 'Data View',
				dataField: 'DataViewName',
				area: 'row',
				},
				{
				caption: 'Data Provider',
				dataField: 'DataProviderName',
				area: 'row',
				},
				{
				caption: 'Region',
				dataField: 'GeographicalEntityShortName',
				area: 'row',
				},
				{
				caption: 'Salon Positioning',
				dataField: 'SalonPositioningName',
				area: 'row',
				},
				{
				caption: 'Salon Size',
				dataField: 'SalonSizeName',
				area: 'row',
				},
				{
				caption: 'Base Year',
				dataField: 'BaseYear',
				area: 'column',
				},
				{
				caption: 'Base Quarter',
				dataField: 'BaseQuarter',
				area: 'column',
				},
				{
				caption: 'Salon Count',
				dataField: 'SalonCount',
				area: 'data',
				dataType: 'number',
				summaryType: 'sum',
				},
				{
				caption: 'Total Amount',
				dataField: 'TotalAmount',
				dataType: 'number',
				summaryType: 'sum',
				format: {
					type: 'currency', precision: 2, currency: 'USD', maximumFractionDigits: 2
				},
				area: 'data',
				},
			],
			store: res
			};
		}
		});
  }

  initPivotDataFields() {
	return {
		fields: [
		{
			caption: 'Report',
			dataField: 'ReportName',
			area: 'filter',
		},
		{
			caption: 'Data View',
			dataField: 'DataViewName',
			area: 'row',
		},
		{
			caption: 'Data Provider',
			dataField: 'DataProviderName',
			area: 'row',
		},
		{
			caption: 'Region',
			dataField: 'GeographicalEntityShortName',
			area: 'row',
		},
		{
			caption: 'Salon Positioning',
			dataField: 'SalonPositioningName',
			area: 'row',
		},
		{
			caption: 'Salon Size',
			dataField: 'SalonSizeName',
			area: 'row',
		},
		{
			caption: 'Base Year',
			dataField: 'BaseYear',
			area: 'column',
		},
		{
			caption: 'Salon Count',
			dataField: 'SalonCount',
			area: 'data',
		},
		{
			caption: 'Total Amount',
			dataField: 'TotalAmount',
			area: 'data',
		},
		],
		store: this.countData
	};
  }
}
